import polyline from '@/tools/polyline'

function getAmenities(info, extentionInfo) {
  return [
    {
      flag: info.truckParkingSportCount || extentionInfo.truckParkingSportCount,
      boolFlag: false,
      tit: 'Parking sports',
      infoPic: require('@/assets/img/poi-detail-icon/parking-spots.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/parking-spots-no.svg'),
      showFlag: (typeof info.truckParkingSportCount == 'undefined' || info.truckParkingSportCount == null) 
        && (typeof extentionInfo.truckParkingSportCount == 'undefined' || extentionInfo.truckParkingSportCount == null)
        ? true : false
    },
    {
      flag: info.overnightParking || extentionInfo.overnightParking,
      boolFlag: true,
      tit: 'Overnight Parking',
      infoPic: require('@/assets/img/poi-detail-icon/overnight-parking.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/overnight-parking-no.svg'),
      showFlag: (typeof info.overnightParking == 'undefined' || info.overnightParking == null)
        && (typeof extentionInfo.overnightParking == 'undefined' || extentionInfo.overnightParking == null)
        ? true : false
    },
    {
      flag: info.showerCount || extentionInfo.showerCount,
      boolFlag: false,
      tit: 'Showers',
      infoPic: require('@/assets/img/poi-detail-icon/showers.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/showers-no.svg'),
      showFlag: (typeof info.showerCount == 'undefined' || info.showerCount == null)
        && (typeof extentionInfo.showerCount == 'undefined' || extentionInfo.showerCount == null)
        ? true : false
    },
    {
      flag: info.wifi || extentionInfo.wifi,
      boolFlag: true,
      tit: 'Wi-Fi',
      infoPic: require('@/assets/img/poi-detail-icon/wi-fi.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/wi-fi-no.svg'),
      showFlag: (typeof info.wifi == 'undefined' || info.wifi == null)
        && (typeof extentionInfo.wifi == 'undefined' || extentionInfo.wifi == null)
        ? true : false
    },
    {
      flag: info.scales || extentionInfo.scales,
      boolFlag: true,
      tit: 'Scales',
      infoPic: require('@/assets/img/poi-detail-icon/scales.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/scales-no.svg'),
      showFlag: (typeof info.scales == 'undefined' || info.scales == null)
        && (typeof extentionInfo.scales == 'undefined' || extentionInfo.scales == null)
        ? true : false
    },
    {
      flag: info.atmCount || extentionInfo.atmCount,
      boolFlag: false,
      tit: 'ATM',
      infoPic: require('@/assets/img/poi-detail-icon/atm.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/atm-no.svg'),
      showFlag: (typeof info.atmCount == 'undefined' || info.atmCount == null)
        && (typeof extentionInfo.atmCount == 'undefined' || extentionInfo.atmCount == null)
        ? true : false
    },
    {
      flag: info.tireCare || extentionInfo.tireCare,
      boolFlag: true,
      tit: 'Tire care',
      infoPic: require('@/assets/img/poi-detail-icon/tire-care.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/tire-care-no.svg'),
      showFlag: (typeof info.tireCare == 'undefined' || info.tireCare == null)
        && (typeof extentionInfo.tireCare == 'undefined' || extentionInfo.tireCare == null)
        ? true : false
    },
    {
      flag: info.petFriendly || extentionInfo.petFriendly,
      boolFlag: true,
      tit: 'Pet friendly',
      infoPic: require('@/assets/img/poi-detail-icon/pet-friendly.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/pet-friendly-no.svg'),
      showFlag: (typeof info.petFriendly == 'undefined' || info.petFriendly == null)
        && (typeof extentionInfo.petFriendly == 'undefined' || extentionInfo.petFriendly == null)
        ? true : false
    },
    {
      flag: info.laundry || extentionInfo.laundry,
      boolFlag: true,
      tit: 'Laundry',
      infoPic: require('@/assets/img/poi-detail-icon/laundry.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/laundry-no.svg'),
      showFlag: (typeof info.laundry == 'undefined' || info.laundry == null)
        && (typeof extentionInfo.laundry == 'undefined' || extentionInfo.laundry == null)
        ? true : false
    },
    {
      flag: info.transfloExpress,
      boolFlag: true,
      tit: 'Transflo Express',
      infoPic: require('@/assets/img/poi-detail-icon/transflo-express.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/transflo-express-no.svg'),
      showFlag: (typeof info.transfloExpress == 'undefined' || info.transfloExpress == null)
        && (typeof extentionInfo.transfloExpress == 'undefined' || extentionInfo.transfloExpress == null)
        ? true : false
    },
    {
      flag: info.rvDumpStations || extentionInfo.rvDumpStations,
      boolFlag: true,
      tit: 'RV dump',
      infoPic: require('@/assets/img/poi-detail-icon/rv-dump-stations.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/rv-dump-stations-no.svg'),
      showFlag: (typeof info.rvDumpStations == 'undefined' || info.rvDumpStations == null)
        && (typeof extentionInfo.rvDumpStations == 'undefined' || extentionInfo.rvDumpStations == null)
        ? true : false
    },
    {
      flag: info.bulkDefCount || extentionInfo.bulkDefCount,
      boolFlag: false,
      tit: 'Bulk Def',
      infoPic: require('@/assets/img/poi-detail-icon/bulk-def.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/bulk-def-no.svg'),
      showFlag: (typeof info.bulkDefCount == 'undefined' || info.bulkDefCount == null)
        && (typeof extentionInfo.bulkDefCount == 'undefined' || extentionInfo.bulkDefCount == null)
        ? true : false
    },
    {
      flag: info.gym || extentionInfo.gym,
      boolFlag: true,
      tit: 'Gym',
      infoPic: require('@/assets/img/poi-detail-icon/gym.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/gym-no.svg'),
      showFlag: (typeof info.gym == 'undefined' || info.gym == null)
        && (typeof extentionInfo.gym == 'undefined' || extentionInfo.gym == null)
        ? true : false
    },
    {
      flag: info.faxScanService || extentionInfo.faxScanService,
      boolFlag: true,
      tit: 'Fax Scan',
      infoPic: require('@/assets/img/poi-detail-icon/fax-scan.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/fax-scan-no.svg'),
      showFlag: (typeof info.faxScanService == 'undefined' || info.faxScanService == null)
        && (typeof extentionInfo.faxScanService == 'undefined' || extentionInfo.faxScanService == null)
        ? true : false
    },
    {
      flag: info.pool || extentionInfo.pool,
      boolFlag: true,
      tit: 'Pool',
      infoPic: require('@/assets/img/poi-detail-icon/pool.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/pool-no.svg'),
      showFlag: (typeof info.pool == 'undefined' || info.pool == null)
        && (typeof extentionInfo.pool == 'undefined' || extentionInfo.pool == null)
        ? true : false
    },
    {
      flag: info.prePass || extentionInfo.prePass,
      boolFlag: true,
      tit: 'Pre pass',
      infoPic: require('@/assets/img/poi-detail-icon/pre-pass.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/pre-pass-no.svg'),
      showFlag: (typeof info.prePass == 'undefined' || info.prePass == null)
        && (typeof extentionInfo.prePass == 'undefined' || extentionInfo.prePass == null)
        ? true : false
    },
    {
      flag: info.wheelAlignment || extentionInfo.wheelAlignment, //客户端Alignment
      boolFlag: true,
      tit: 'Wheel',
      infoPic: require('@/assets/img/poi-detail-icon/alignment.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/alignment-no.svg'),
      showFlag: (typeof info.wheelAlignment == 'undefined' || info.wheelAlignment == null)
        && (typeof extentionInfo.wheelAlignment == 'undefined' || extentionInfo.wheelAlignment == null)
        ? true : false
    },
    {
      flag: info.twic || extentionInfo.twic,
      boolFlag: true, //后端没有这个值
      tit: 'TWIC',
      infoPic: require('@/assets/img/poi-detail-icon/twic.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/twic-no.svg'),
      showFlag: (typeof info.twic == 'undefined' || info.twic == null)
        && (typeof extentionInfo.twic == 'undefined' || extentionInfo.twic == null)
        ? true : false
    },
    {
      flag: info.appointment || extentionInfo.appointment,
      boolFlag: true, //后端没有这个值
      tit: 'Appointment',
      infoPic: require('@/assets/img/poi-detail-icon/appointment.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/appointment-no.svg'),
      showFlag: (typeof info.appointment == 'undefined' || info.appointment == null)
        && (typeof extentionInfo.appointment == 'undefined' || extentionInfo.appointment == null)
        ? true : false
    },
    {
      flag: info.cbChannel || extentionInfo.cb_channel || extentionInfo.cbChannel,
      boolFlag: false, //后端没有这个值
      tit: 'CB Channel',
      infoPic: require('@/assets/img/poi-detail-icon/cb-chaneel.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/cb-chaneel-no.svg'),
      showFlag: (typeof info.cbChannel == 'undefined' || info.cbChannel == null)
        && (typeof extentionInfo.cb_channel == 'undefined' || extentionInfo.cb_channel == null)
        && (typeof extentionInfo.cbChannel == 'undefined' || extentionInfo.cbChannel == null)
        ? true : false
    },
    {
      flag: info.vending || extentionInfo.vending,
      boolFlag: true, //后端没有这个值
      tit: 'Vending',
      infoPic: require('@/assets/img/poi-detail-icon/vending.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/vending-no.svg'),
      showFlag: (typeof info.vending == 'undefined' || info.vending == null)
        && (typeof extentionInfo.vending == 'undefined' || extentionInfo.vending == null)
        ? true : false
    },
    {
      flag: info.restrooms || extentionInfo.restrooms,
      boolFlag: true, //后端没有这个值
      tit: 'Restrooms',
      infoPic: require('@/assets/img/poi-detail-icon/restrooms.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/restrooms-no.svg'),
      showFlag: (typeof info.restrooms == 'undefined' || info.restrooms == null)
        && (typeof extentionInfo.restrooms == 'undefined' || extentionInfo.restrooms == null)
        ? true : false
    },
    {
      flag: info.kids || extentionInfo.kids, //后端没有这个值
      boolFlag: true,
      tit: 'Kids',
      infoPic: require('@/assets/img/poi-detail-icon/kids.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/kids-no.svg'),
      showFlag: (typeof info.kids == 'undefined' || info.kids == null)
        && (typeof extentionInfo.kids == 'undefined' || extentionInfo.kids == null)
        ? true : false
    },
    {
      flag: info.driverLounge || extentionInfo.driver_lounge || extentionInfo.driverLounge, //后端没有这个值
      boolFlag: true,
      tit: 'Driver Lounge',
      infoPic: require('@/assets/img/poi-detail-icon/driver-lounge.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/driver-lounge-no.svg'),
      showFlag: (typeof info.driverLounge == 'undefined' || info.driverLounge == null)
        && (typeof extentionInfo.driver_lounge == 'undefined' || extentionInfo.driver_lounge == null)
        && (typeof extentionInfo.driverLounge == 'undefined' || extentionInfo.driverLounge == null)
        ? true : false
    },
    {
      flag: info.vehicleRestraints || extentionInfo.vehicle_restraints || extentionInfo.vehicle_restraints, //后端没有这个值
      boolFlag: true,
      tit: 'Vehicle',
      infoPic: require('@/assets/img/poi-detail-icon/vehicle-restraints.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/vehicle-restraints-no.svg'),
      showFlag: (typeof info.vehicleRestraints == 'undefined' || info.vehicleRestraints == null)
        && (typeof extentionInfo.vehicle_restraints == 'undefined' || extentionInfo.vehicle_restraints == null)
        && (typeof extentionInfo.vehicleRestraints == 'undefined' || extentionInfo.vehicleRestraints == null)
        ? true : false
    },
    {
      flag: info.dockLeveller || extentionInfo.dock_leveller || extentionInfo.dockLeveller, //后端没有这个值
      boolFlag: true,
      tit: 'Dock Leveller',
      infoPic: require('@/assets/img/poi-detail-icon/dock-leveller.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/dock-leveller-no.svg'),
      showFlag: (typeof info.dockLeveller == 'undefined' || info.dockLeveller == null)
        && (typeof extentionInfo.dock_leveller == 'undefined' || extentionInfo.dock_leveller == null)
        && (typeof extentionInfo.dockLeveller == 'undefined' || extentionInfo.dockLeveller == null)
        ? true : false
    },
    {
      flag: info.dockDoorClearance || extentionInfo.dockDoorClearance || extentionInfo.dock_door_clearance,
      boolFlag: true,
      tit: 'Dock Door Clearance',
      infoPic: require('@/assets/img/poi-detail-icon/dock-door-clearance.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/dock-door-clearance-no.svg'),
      showFlag: (typeof info.dockDoorClearance == 'undefined' || info.dockDoorClearance == null)
        && (typeof extentionInfo.dockDoorClearance == 'undefined' || extentionInfo.dockDoorClearance == null)
        && (typeof extentionInfo.dock_door_clearance == 'undefined' || extentionInfo.dock_door_clearance == null)
        ? true : false
    },
    {
      flag: info.gloves || extentionInfo.gloves, //后端没有这个值
      boolFlag: true,
      tit: 'Gloves',
      infoPic: require('@/assets/img/poi-detail-icon/gloves.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/gloves-no.svg'),
      showFlag: (typeof info.gloves == 'undefined' || info.gloves == null)
        && (typeof extentionInfo.gloves == 'undefined' || extentionInfo.gloves == null)
        ? true : false
    },
    {
      flag: info.chocks || extentionInfo.chocks, //后端没有这个值
      boolFlag: true,
      tit: 'Chocks',
      infoPic: require('@/assets/img/poi-detail-icon/chocks.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/chocks-no.svg'),
      showFlag: (typeof info.chocks == 'undefined' || info.chocks == null)
        && (typeof extentionInfo.chocks == 'undefined' || extentionInfo.chocks == null)
        ? true : false
    },
    {
      flag: info.closedToeShoes || extentionInfo.closedToeShoes || extentionInfo.closed_toe_shoes, //后端没有这个值
      boolFlag: true,
      tit: 'Closed Toe',
      infoPic: require('@/assets/img/poi-detail-icon/closed-toe-shoes.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/closed-toe-shoes-no.svg'),
      showFlag: (typeof info.closedToeShoes == 'undefined' || info.closedToeShoes == null)
        && (typeof extentionInfo.closedToeShoes == 'undefined' || extentionInfo.closedToeShoes == null)
        && (typeof extentionInfo.closed_toe_shoes == 'undefined' || extentionInfo.closed_toe_shoes == null)
        ? true : false
    },
    {
      flag: info.heavyHauler || extentionInfo.heavyHauler || extentionInfo.heavy_hauler, //后端没有这个值
      boolFlag: true,
      tit: 'Heavy Hauler',
      infoPic: require('@/assets/img/poi-detail-icon/heavy-hauler.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/heavy-hauler-no.svg'),
      showFlag: (typeof info.heavyHauler == 'undefined' || info.heavyHauler == null)
        && (typeof extentionInfo.heavyHauler == 'undefined' || extentionInfo.heavyHauler == null)
        && (typeof extentionInfo.heavy_hauler == 'undefined' || extentionInfo.heavy_hauler == null)
        ? true : false
    },
    {
      flag: info.hardHat || extentionInfo.hardHat || extentionInfo.hard_hat, //后端没有这个值
      boolFlag: true,
      tit: 'hard Hat',
      infoPic: require('@/assets/img/poi-detail-icon/hard-hat.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/hard-hat-no.svg'),
      showFlag: (typeof info.hardHat == 'undefined' || info.hardHat == null)
        && (typeof extentionInfo.hardHat == 'undefined' || extentionInfo.hardHat == null)
        && (typeof extentionInfo.hard_hat == 'undefined' || extentionInfo.hard_hat == null)
        ? true : false
    },
    {
      flag: info.glasses || extentionInfo.glasses, //后端没有这个值
      boolFlag: true,
      tit: 'Safety Glasses',
      infoPic: require('@/assets/img/poi-detail-icon/safety-glasses.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/safety-glasses-no.svg'),
      showFlag: (typeof info.glasses == 'undefined' || info.glasses == null)
        && (typeof extentionInfo.glasses == 'undefined' || extentionInfo.glasses == null)
        ? true : false
    },
    {
      flag: info.lumperService || extentionInfo.lumper_service || extentionInfo.lumperService, //后端没有这个值
      boolFlag: true,
      tit: 'Lumper service',
      infoPic: require('@/assets/img/poi-detail-icon/lumper-service.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/lumper-service-no.svg'),
      showFlag: (typeof info.lumperService == 'undefined' || info.lumperService == null)
        && (typeof extentionInfo.lumper_service == 'undefined' || extentionInfo.lumper_service == null)
        && (typeof extentionInfo.lumperService == 'undefined' || extentionInfo.lumperService == null)
        ? true : false
    },
    {
      flag: info.dockSignalLights || extentionInfo.dockSignalLights || extentionInfo.dock_signal_lights, //后端没有这个值
      boolFlag: true,
      tit: 'Dock Signal Lights',
      infoPic: require('@/assets/img/poi-detail-icon/cock-signal-lights.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/cock-signal-lights-no.svg'),
      showFlag: (typeof info.dockSignalLights == 'undefined' || info.dockSignalLights == null)
        && (typeof extentionInfo.dockSignalLights == 'undefined' || extentionInfo.dockSignalLights == null)
        && (typeof extentionInfo.dock_signal_lights == 'undefined' || extentionInfo.dock_signal_lights == null)
        ? true : false
    },
    {
      flag: info.dockBarrier || extentionInfo.dockBarrier || extentionInfo.dock_barrier, //后端没有这个值
      boolFlag: true,
      tit: 'Dock barrier',
      infoPic: require('@/assets/img/poi-detail-icon/dock-barrier.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/dock-barrier-no.svg'),
      showFlag: (typeof info.dockBarrier == 'undefined' || info.dockBarrier == null)
        && (typeof extentionInfo.dockBarrier == 'undefined' || extentionInfo.dockBarrier == null)
        && (typeof extentionInfo.dock_barrier == 'undefined' || extentionInfo.dock_barrier == null)
        ? true : false
    },
    {
      flag: info.liftgateOnly || extentionInfo.liftgateOnly || extentionInfo.liftgate_only, //后端没有这个值
      boolFlag: true,
      tit: 'Liftgate Only',
      infoPic: require('@/assets/img/poi-detail-icon/detailsliftgate-only.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/detailsliftgate-only-no.svg'),
      showFlag: (typeof info.liftgateOnly == 'undefined' || info.liftgateOnly == null)
        && (typeof extentionInfo.liftgateOnly == 'undefined' || extentionInfo.liftgateOnly == null)
        && (typeof extentionInfo.liftgate_only == 'undefined' || extentionInfo.liftgate_only == null)
        ? true : false
    },
    {
      flag: info.loadVerification || extentionInfo.loadVerification || extentionInfo.load_verification, //后端没有这个值
      boolFlag: true,
      tit: 'Load Verfication',
      infoPic: require('@/assets/img/poi-detail-icon/load-verification.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/load-verification-no.svg'),
      showFlag: (typeof info.loadVerification == 'undefined' || info.loadVerification == null)
        && (typeof extentionInfo.loadVerification == 'undefined' || extentionInfo.loadVerification == null)
        && (typeof extentionInfo.load_verification == 'undefined' || extentionInfo.load_verification == null)
        ? true : false
    },
    {
      flag: info.washout || extentionInfo.washout, //后端没有这个值
      boolFlag: true,
      tit: 'Washout',
      infoPic: require('@/assets/img/poi-detail-icon/washout.svg'),
      infoPicNo: require('@/assets/img/poi-detail-icon/washout-no.svg'),
      showFlag: (typeof info.washout == 'undefined' || info.washout == null)
        && (typeof extentionInfo.washout == 'undefined' || extentionInfo.washout == null)
        ? true : false
    }
  ]
}

export function basicInfoToAllData(info) {
  let longitude = info.location ? info.location[0] : null
  let latitude = info.location ? info.location[1] : null

  let highway = ''
  if (info.highway) {
    if (info.exit) {
      highway = info.highway + ', exit ' + info.exit
    } else {
      highway = info.highway
    }
  } else {
    highway = ''
  }

  let dockInfo = {}
  let extentionInfo = info.extensionInfo ? JSON.parse(info.extensionInfo) : {}
  // const dockArr = ['runningTime','lateWaittime','bestArrivaltime','dockDoorClearance', 'foklift', 'crane',  'yardSpeedLimit',  'internalTemp']
  const dockArr = ['running_time', 'late_waittime', 'best_arrivaltime', 'dock_door_clearance', 'foklift', 'crane', 'yard_speed_limit', 'internal_temp']
  dockArr.forEach(item => {
    if (extentionInfo[item]) {
      dockInfo[item] = extentionInfo[item]
    } else {
      dockInfo[item] = ''
    }
  })

  return {
    highway,
    dockInfo,
    latitude,
    longitude,
    lanLong: latitude && longitude ? `${latitude.toFixed(6)}, ${longitude.toFixed(6)}` : '',
    title: info.title,
    address: info.address || '',
    phone: info.phone,
    zipCode: info.zip,
    tid: info.tid,
    sid: info.sid,
    pointId: info.ident,
    ident: info.ident,
    gerInfo: getAmenities(info, extentionInfo)
  }
}

export function formatPoiReviewData(list) {
  try {
    return list.map(item => ({
      ...item,
      avatar: item.user_image || require('@/assets/img/poi-detail-icon/headCopy.png'),
      nickname: item.nickname || 'Anonymous User',
      rating: item.rating,
      content: item.text,
      updatedTime: item.updated_at
    }))
  } catch {
    return []
  }
}

export function formatRestaurantData(list) {
  try {
      return list.map(item => ({
          title: item.name,
          rating: item.rating,
          review: item.review_count,
          type: item.categories.map(item => item.title).join(','),
          pic: item.image_url || require('@/assets/img/poi-detail-icon/rest-def.png'),
          near: item.distance ? (item.distance * 0.000621371192).toFixed(2) : null
      }))
  } catch {
      return []
  }
}

export function formatPoiFence(result) {
  let info = {}
  try {
      info = result.extensionInfo
      info.fence = polyline.decodePolyline(info.fence)
      info.in = polyline.decodePolyline(info.in)
      info.inAccessRoad = polyline.decodePolyline(info.inAccessRoad)
      info.out = polyline.decodePolyline(info.out)
      info.outAccessRoad = polyline.decodePolyline(info.outAccessRoad)
  } catch {
      info = {}
  }
  return info
}

export function formatFacilityReviewData(list) {
  try {
      return list.map(item => ({
          ...item,
          avatar: require('@/assets/img/poi-detail-icon/headCopy.png'),
          nickname: item.nickname || 'Anonymous User',
          rating: item.rating,
          content: item.content,
          updatedTime: item.updatedTime
      }))
  } catch {
      return []
  }
}